import Shuffle from "shufflejs";

class ShuffleGrid {
    constructor(element) {
        this.el = element;
        this.init();
    }

    init() {
        this.shuffle();
        this.observe(this.el);
    }

    shuffle() {
        const sizer = document.querySelector("[data-shuffle-sizer]");
        const shuffleItems = this.el.querySelectorAll("[data-shuffle-item]");

        this.el.style.setProperty(
            "--shuffle-item-width",
            sizer.offsetWidth + "px",
        );

        this.el.shuffle_instance = new Shuffle(this.el, {
            itemSelector: "[data-shuffle-item]",
            sizer: sizer,
        });
    }

    // Watch iframes inside the Shuffle grid for changes and reshuffle if their height changes.
    observe(listing) {
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.attributeName == "height") {
                    if (listing.hasAttribute("data-shuffle")) this.shuffle();
                }
            }
        };

        const observer = new MutationObserver(callback);

        const interval = setInterval(() => {
            let items = listing.querySelectorAll("iframe");

            [...items].forEach((el) => {
                observer.observe(el, config);
            });
        }, 500);

        // Eventually disconnect the observer and clear the interval
        setTimeout(() => {
            clearInterval(interval);
            observer.disconnect();
        }, 5000);
    }
}
document.addEventListener("DOMContentLoaded", () => {
    const shuffles = document.querySelectorAll("[data-shuffle]");
    shuffles.forEach((element) => {
        new ShuffleGrid(element);
    });
});

export default ShuffleGrid;
